import { createSlice } from "@reduxjs/toolkit";

const stepperSlice = createSlice({
  name: "stepper",
  initialState: {
    stepper: 0,
    stepsData:[]
  },
  reducers: {
    stepperValue: (state, action) => {
      const index = state.stepsData.findIndex((item) => item?.navigation === action.payload);
       state.stepper = index >= 0 ? index : 0
    },
    updateStepsData: (state, action) => {
      state.stepsData = action.payload;
    },
  },
});

export default stepperSlice.reducer;
export const { stepperValue, updateStepsData } = stepperSlice.actions;
